import { BaseService } from '../../infra/base.service'
import type { CitiesRepository } from './cities.repository'
import type { City } from './city'

export class CitiesService extends BaseService<City> {
    constructor(private rep: CitiesRepository) {
        super(rep)
    }
}
